import Ract from "react";
import Axios from "axios";
import toast from "react-hot-toast";
import { ServiceUrl } from "../utils/serviceUrl";
import { APP_TYPE, DB_POSTFIX } from "../utils";

export const listAll = async () => {
  return new Promise((resolve, reject) => {
    Axios.get(ServiceUrl.ADMIN_SETTINGS.LIST)
      .then(function ({ data }) {
        if (data.status != "1") {
          toast.error(data.message || "Error");
        }
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listSettingsFields = async (encode = false) => {
  return new Promise((resolve, reject) => {
    let url = ServiceUrl.ADMISSION.SETTINGS;
    if (encode) url += "?sta=1&admission=1";
    if (APP_TYPE == "SAAS") {
      if (encode) url += "&sadb=" + DB_POSTFIX;
      else url += "?sadb=" + DB_POSTFIX;
    }
    Axios.get(url)
      .then(function ({ data }) {
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listAllDisabilityCategory = async () => {
  return new Promise((resolve, reject) => {
    let url = ServiceUrl.ADMISSION.DISABILITY_LIST;
    Axios.get(url)
      .then(function ({ data }) {
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listAllCommunity = async () => {
  return new Promise((resolve, reject) => {
    let url = ServiceUrl.ADMISSION.COMMUNITYLIST;
    if (APP_TYPE == "SAAS") {
      url += "?sadb=" + DB_POSTFIX;
    }
    Axios.get(url)
      .then(function ({ data }) {
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listCaste = async (id = false) => {
  return new Promise((resolve, reject) => {
    let url = ServiceUrl.ADMISSION.CASTELIST;
    if (id) url += "?community_id=" + id;
    if (APP_TYPE == "SAAS") {
      if (id) url += "&sadb=" + DB_POSTFIX;
      else url += "?sadb=" + DB_POSTFIX;
    }
    Axios.get(url)
      .then(function ({ data }) {
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};

export const listUniversity = async () => {
  return new Promise((resolve, reject) => {
    let url = ServiceUrl.ADMISSION.UNIVERSITYLIST;
    Axios.get(url)
      .then(function ({ data }) {
        resolve(data.data);
      })
      .catch(function (error) {
        //resolve([]);
        return [];
      });
  });
};
